export default __webpack_public_path__ + "static/media/lp-02-exercise-03.9f4a740b.jpg";